import { render, staticRenderFns } from "./WizardBase.vue?vue&type=template&id=2ee69e5c&scoped=true&"
import script from "./WizardBase.vue?vue&type=script&lang=js&"
export * from "./WizardBase.vue?vue&type=script&lang=js&"
import style0 from "./WizardBase.vue?vue&type=style&index=0&id=2ee69e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee69e5c",
  null
  
)

export default component.exports